module.exports = __webpack_public_path__ + "img/04.c7eacec7.png";